<div class="chennai-container">
  <app-tabla [ec2Repositories]="repositories"></app-tabla>
</div>
